<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-文章-编辑
    -->
  <div class="product-add pb50" v-loading="loading">
    <!--编辑文章-->
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">编辑文章</div>
      <el-form-item label="文章标题" prop="article_title"><el-input v-model="form.article_title" placeholder="请输入文章标题" class="max-w460"></el-input></el-form-item>
      <el-form-item label="描述" prop="dec"><el-input v-model="form.dec" placeholder="请输入文章描述" class="max-w460"></el-input></el-form-item>
      <el-form-item label="文章缩略图">
        <div>
          <el-button type="primary" @click="openUpload(1)">上传图片</el-button>
          <img class="mt10" :src="form.image.file_path"  width="120px;" alt="" />

        </div>
      </el-form-item>
      <!-- <el-form-item label="视频" prop="video">
        <el-input type="text" v-model="form.video_url" placeholder="请选择视频" class="max-w460">
          <template slot="append">
            <el-button icon="el-icon-picture-outline" @click="openVideoUpload">选择视频
            </el-button>
          </template>
        </el-input>

        <Upload v-if="isVideoUpload" :isupload="isVideoUpload" type="video" @returnImgs="returnVideosFunc">上传视频</Upload>
      </el-form-item> -->
<!-- 
      <div class="d-s-c mt16">

        <div class="d-s-c" >
       
          <RelationProduct :form="form" :type="type"></RelationProduct>

        </div>
        <div class="gray9" style="margin-left:10px;">针对视频</div>

      </div> -->

      <!-- 关联会员 -->
      <!-- <el-form-item label="选择会员">
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">选择会员</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img v-if="user_info.avatarUrl" :src="user_info.avatarUrl" width="100" height="100" />
            <div>{{ user_info.nickName }}</div>
          </div>
        </el-row>
        <el-button @click="remove" v-if="form.user_id!=''">移除会员</el-button>
      </el-form-item> -->


      <el-form-item label="文章分类">
        <el-select v-model="form.category_id">
          <template v-for="cat in category">
            <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>
            <template v-if="cat.child !== undefined" v-for="two in cat.child">
              <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px;"></el-option>
            </template>
          </template>
        </el-select>

 
      </el-form-item>
      <el-form-item label="虚拟阅读量"><el-input type="number" v-model="form.virtual_views" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
      <el-form-item label="文章状态">
        <el-radio-group v-model="form.article_status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="附件内容">
        <div>
          <el-button type="primary" @click="openUpload(2)">上传附件</el-button>
          <div class="gray" v-if="form.attachment.name">
            {{form.attachment.name}}
            <span @click="delFile">删除</span>
          </div>

        </div>

      </el-form-item>
      <el-form-item label="文章内容">
        <div class="edit_container">
          <Uediter v-if="!loading" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>
      <el-form-item label="排序"><el-input type="number" v-model="form.article_sort" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc" :loading="loading">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    <GetUser :is_open="open_add" :multi="false" @close="closeDialogFunc"></GetUser>

  </div>
</template>

<script>
import ArticleApi from '@/api/article.js';
import Uediter from '@/components/UE.vue';
import Upload from '@/components/file/Upload';
  import GetUser from '@/components/user/GetUser.vue';
import RelationProduct from './Relationproduct';
export default {
  components: {
    /*编辑器*/
    Uediter,
    /*图片上传*/
    Upload: Upload,
    RelationProduct,
    GetUser
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*是否上传图片*/
      isupload: false,
      isVideoUpload: false,
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        article_title: '',
        category_id: '',
        image_id: '',
        image:{},
        video_url:'',
        article_sort: 1,
        article_status: '0',
        virtual_views: 1,
        article_content: '',
        attachment:{}
      },
      /*新闻类别*/
      category: [],
      /*验证规则*/
      rules: {
        article_title: [{ required: true, message: '请输入文章标题', trigger: 'blur' }],
        dec: [{ required: true, message: '请输入文章描述', trigger: 'blur' }]
      },
      upload_type:1,
      isproduct:false,
      product:[],
      type:"edit",
      open_add:false,
      user_info:{
        avatarUrl:"",
        nickName:""
      }
    };
  },
  created() {

    this.getDetail();

  },

  methods: {
     /*打开弹出层*/
     addClick() {
        this.open_add = true;
      },

      /*关闭获取用户弹窗*/
      closeDialogFunc(e) {
        console.log("e",e)
        if (e.type != 'error') {
          this.user_info = e.params;
          this.form.user_id = e.params.user_id;
        }
        this.open_add = false;
      },
      remove(){
        console.log("移除");
        this.user_info = {
          nickName:"",
          avatarUrl:""
        }
        this.form.user_id = "";
      },
    delFile(){
      this.form.attachment = {};
    },
    /* 打开视频 */
    openVideoUpload() {
      this.isVideoUpload = true;
    },
    /* 获取视频 */
    returnVideosFunc(e) {
      console.log(e);
      if (e != null && e.length > 0) {
        this.form.video_url = e[0].file_path;
      }
      this.isVideoUpload = false;
    },
    /*上传*/
    openUpload(upload_type) {
      this.upload_type = upload_type;
      this.isupload = true;
    },

    getContent: function() {
      return this.$refs.ue.getUEContent();
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        if(self.upload_type==1){
          this.form.image_id = e[0].file_id;
          this.form.image.file_path = e[0].file_path;
        }else{
          this.form.attachment.file_url = e[0].file_path;
          this.form.attachment.name = e[0].real_name;
        }

      }
      this.isupload = false;
    },

    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      const params = self.$route.query.article_id;
      ArticleApi.toEditArticle({article_id: params},true).then(res => {
        self.ueditor.text = res.data.model.article_content;
        self.form = res.data.model;
        if(!self.form.image){
          self.form.image={};
        }
        if(!self.form.attachment){
          self.form.attachment={};
        }
        self.category = res.data.catgory;
        this.form.product = this.form.product?this.form.product:[]
        self.user_info = res.data.model.user_info;
        self.loading = false;
      })
        .catch(error => {});
    },

    /*修改文章*/
    onSubmit() {
      let self = this;
      let params = this.form;
      self.form.article_content = this.$refs.ue.getUEContent();
      console.log("product",self.form.product,self.form.product.length);
      if(self.form.product.length <= 0){
          params.product_ids =  [];
      }
      // 取到路由带过来的参数
      ArticleApi.editArticle(params, true)
        .then(data => {
          self.$message({
            message: data.msg,
            type: 'success'
          });
          self.$router.push('/plus/article/index');
        })
        .catch(error => {});
    },

    /*取消添加，返回文章列表*/
    cancelFunc() {
      this.$router.push({
        path: '/plus/article/index'
      });
    },

    /*产品列表弹出层*/
    openProduct() {
      this.isproduct = true;
    },
    /*删除商品*/
    deleteFunc(i) {
      console.log("删除商品",i,this.form);
      this.form.product_ids.splice(i, 1);
      this.form.product.splice(i, 1);

    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/article/article/edit.vue